@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

// override table styles from main.css: .table-tbody > tr > td
// we need more padding
.table-body {
  border: 1px solid var(--default--header--border-color--3);
  border-radius: 4px;
  & > tr > * {
    padding: @space-16 !important;
  }
}

// override table styles from main.css: .table-thead > tr > th
// we need more padding
.table-column-header {
  border-bottom: 1px solid var(--default--header--border-color--3);
  border-radius: 4px;
  & > tr > th {
    color: var(--grey-800);
    font-weight: 500;
  }
}
